import { FC } from 'react';
import { ProductInfoType } from '../../types/product-info-type';
import classes from '../../asset/css/subscription-detail/product-list.module.css';
import { ProductInfo } from './ProductInfo';

export const PausedProductList: FC<{
  productInfos: ProductInfoType[];
  loading: boolean;
  changeActiveFunc: (active: boolean, variantId: string, planId?: string, lineId?: string) => void;
}> = ({ productInfos, loading, changeActiveFunc }) => {
  if (productInfos.length === 0) {
    return <></>;
  }

  const productInfosHtml = productInfos.map((productInfo, idx) => {
    return (
      <ProductInfo
        active={false}
        productInfo={productInfo}
        loading={loading}
        changeActiveFunc={changeActiveFunc}
        key={idx}
      />
    );
  });

  return (
    <>
      <div className={classes.mypage_subsc_list_section}>
        <h4 className={classes.mypage_subsc_list_title}>休止中の商品</h4>
        <ul className={classes.mypage_subsc_list}>{productInfosHtml}</ul>
      </div>
    </>
  );
};
